import { combineReducers } from 'redux';
import chartsReducer from 'redux/modules/chartSlice';
import authReducer from 'redux/reducers/auth';
import errorReducer from 'redux/reducers/error';
import labsReducer from 'redux/reducers/labs';
import preferencesReducer from 'redux/reducers/preferences';

export default combineReducers({
  error: errorReducer,
  labs: labsReducer,
  auth: authReducer,
  preferences: preferencesReducer,
  charts: chartsReducer,
});
